'use client';
import {useTableParams} from "../../core/hooks/table-params";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {IInstitution, XmasPackageListEntry} from "../../core/interfaces";
import Loader from "../../core/components/Loader";
import {IColumn, Table} from "../../core/components/Table";
import {Pagination} from "../../core/components/Pagination";
import {Button} from "@mui/material";
import {OrdersSearchPaginationParams} from "../../core/services/utils";
import {Link} from "react-router-dom";
import {getAllXmasPackages} from "../../services/orders";

export const XmasPackageListPage: React.FC = (): JSX.Element => {
    const {
        page,
        setPage,
        size,
        setSize,
        totalElements,
        setTotalElements,
        sortBy,
        setSortBy,

    } = useTableParams({
        defaultSortBy: 'updatedAt',
    }
    )

    const [isError, setIsError] = useState<boolean>(false)
    const [showMessageBox, setShowMessageBox] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [packages, setPackages] = useState<XmasPackageListEntry[]>([])
    const [isCheck, setIsCheck] = useState<string[]>([])
    const searchParams = useRef<{ [key: string]: string }>({})
    const timer = useRef<NodeJS.Timeout | null>(null)
    const [editMode, setEditMode] = useState<boolean>(false)
    const [currentInstitution, setCurrentInstitution] = useState<IInstitution>()
    const [showCreateInstitutionModal, setShowCreateInstitutionModal] = useState<boolean>(false)
    const getData = useCallback(async () => {
        try {
            setLoading(true)
            const params: OrdersSearchPaginationParams = {
                page,
                size,
                sortBy,
            };
            params.text = searchParams.current.orderDispNumber
            params.phone = searchParams.current.userPhone
            params.name = searchParams.current.userName
            const response = await getAllXmasPackages(params)
            setTotalElements(response.data.totalElements)
            setPackages(response.data.content)
            setPage(page + 1)
        } catch (e) {
            if (e instanceof Error) {
                setIsError(true)
                setShowMessageBox(true)
                setMessage(e.message)
            } else {
                console.error(e)
            }
        } finally {
            setLoading(false)
        }
    }, [page, size, sortBy])

    useEffect(() => {
        getData()
    }, [page, size, sortBy])

    const handleSortBy = (sort: string) => {
        if (sort === sortBy) {
            setSortBy('updatedAt')
        } else {
            setSortBy(sort)
        }
    }

    const pageChange = async (newPage: number) => {
        setPage(newPage)
    }

    const handleSearchParams = useCallback(
        async (col: IColumn, q: string) => {
            if (timer.current) {
                clearTimeout(timer.current)
            }

            searchParams.current = {
                ...searchParams.current,
                [col.accessor]: q,
            }

            const newTimer = setTimeout(async () => {
                setLoading(true)
                try {
                    const params: OrdersSearchPaginationParams = {
                        page: 0,
                        size,
                        sortBy,
                    }


                    params.text = searchParams.current.orderDispNumber
                    params.phone = searchParams.current.userPhone
                    params.name = searchParams.current.userName
                    console.log(params);
                    const { data: res, status } = await getAllXmasPackages(params)
                    if (status === 200) {
                        setPackages(res.content)
                        setTotalElements(res.totalElements)
                        setSize(res.size)
                        setPage(res.pageNumber + 1)
                    }
                } catch (err) {
                    console.log(err)
                } finally {
                    setLoading(false)
                }
            }, 2000)
            timer.current = newTimer
        },
        [page, size, sortBy],
    )

    const columns: IColumn[] = [
        {
            title: 'OrderNumber',
            accessor: 'orderDispNumber',
            sortable: true,
            searchable: true
        },
        {
            title: 'User Name',
            accessor: 'userName',
            sortable: true,
            searchable: true
        },
        {
            title: 'User phone',
            accessor: 'userPhone',
            sortable: true,
            searchable: true
        },
        {
            title: 'Name',
            accessor: 'name',
            sortable: true,
            searchable: false
        },
        {
            title: 'Age group',
            accessor: 'ageGroup',
            sortable: true,
            searchable: false
        },
        {
            title: 'Status',
            accessor: 'status',
            sortable: true,
            searchable: false
        },
        {
            title: 'Created At',
            accessor: '',
            render: (row) => (
                <span>{new Date(row.createdAt).toLocaleDateString("ro", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                })}</span>
            ),
            searchable: false
        },
        {
            title: 'Assign Books',
            accessor: '',
            render: (row) => (

                <Link to={`/orders/christmas-package/${row.id}`}>
                    <Button className="btn btn-secondary">
                        Assign
                    </Button>
                </Link>
            ),
        }
    ]

    return (
        <>
            <div
                style={{
                    padding: 20,
                    backgroundColor: '#F8F8F8',
                    position: 'relative',
                }}
            >
                {loading && <Loader />}
                <div
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: 20,
                    }}
                    >
                    <h2>Christmas Packages</h2>
                </div>
                <div className="overflow-x-auto">
                <Table
                    handleSearch={handleSearchParams}
                    isCheck={isCheck}
                    columns={columns}
                    handleSortBy={handleSortBy}
                    data={packages}
                />
                </div>
                <Pagination
                    size={size}
                    totalElements={totalElements}
                    setSize={setSize}
                    page={page + 1}
                    changePage={pageChange}
                />

            </div>
        </>
    )
}